import React, { useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { InputLabel, FormControl, FormHelperText } from '@mui/material';
import { Label } from '../../components/Styled/elements';

export const StyledLabel = styled(Label)`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  :first-letter{
    text-transform: uppercase;
  };
`;

export const withEditor = (labelProps = {}) => (WrappedComponent) => {
  function Editored({
    label, id, errors, helpText, ...props
  }) {
    const eId = useMemo(
      () => id || Math.random().toString(16).slice(2),
      [id],
    );
    return (
      <FormControl fullWidth margin="dense">
        {label && (<InputLabel htmlFor={eId} error={!!errors} {...labelProps}>{label}</InputLabel>)}
        <WrappedComponent id={eId} errored={!!errors} {...props} />
        <FormHelperText error>{errors}</FormHelperText>
        {helpText && (
          <FormHelperText>{helpText}</FormHelperText>
        )}
      </FormControl>
    );
  }

  Editored.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string),
    helpText: PropTypes.string,
  };

  Editored.defaultProps = {
    id: null,
    label: 'Поле без назви',
    errors: null,
    helpText: null,
  };

  return Editored;
};
